import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthApiService } from '../infra/service';
import { TokenData } from './types';
import { User } from '../../user/core/type';

/**
 * Service class to handle ingredients manipulation.
 */
@Injectable({ providedIn: 'root', useClass: AuthApiService })
export abstract class AuthService {
  abstract get authenticatedUser(): Observable<User>;

  /**
   * Verifica o token no backend garantindo que o mesmo esteja valido
   */
  abstract isLoggedIn(): Observable<boolean>;

  /**
   * Remove o token do cache local e solicita cancelamento do tgt no backend
   */
  abstract logout(): Observable<void>;

  /**
   * Realiza login via credenciais
   * @param data
   */
  abstract login(data: {
    cpf: string;
    password: string;
  }): Observable<{ jwt: string }>;

  /**
   * Solicita email com codigo de confirmacão
   * @param data
   */
  abstract recoverRequest(email: string): Observable<void>;

  /**
   * Verifica se o código de recuperação informado está válido
   * @param data
   */
  abstract recoverValidate(code: string): Observable<void>;

  /**
   * Redefine a senha
   * @param data
   */
  abstract recoverReset(
    code: string,
    pass: string,
    passConfirm: string
  ): Observable<void>;

  /**
   * Recebe um jwt e raliza o teste de autenticidade
   * - Se for valido retornara os dados do usuario autenticado
   * - Se for invalido retornara um erro
   * @param jwt
   */
  abstract saveJwt(
    jwt: string
  ): Observable<Pick<TokenData, 'id'>>;
}
